import { selector } from "recoil"
import { quizResponseListState } from "../atoms"

const quizResponseCntSelector = selector({
  key: "quizResponseCntSelector",
  get: ({ get }) => {
    const currentResponseList = get(quizResponseListState)
    let cnt = 0
    currentResponseList.forEach((response) => {
      if (response) {
        cnt++
      }
    })
    return cnt
  },
})

export default quizResponseCntSelector
